import { render, staticRenderFns } from "./NoTipsModal.vue?vue&type=template&id=20eaca9b&scoped=true"
import script from "./NoTipsModal.vue?vue&type=script&lang=js"
export * from "./NoTipsModal.vue?vue&type=script&lang=js"
import style0 from "./NoTipsModal.vue?vue&type=style&index=0&id=20eaca9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eaca9b",
  null
  
)

export default component.exports